import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/custom_report_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  target_type_eq: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'targetType',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'CustomReport',
      options: ['monthly', 'weekly', 'daily'],
    },
    model_name: 'CustomReport',
    column_name: 'kind',
  },
  order_by_order_amount: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByOrderAmount',
  },
  order_by_order_amount_change_rate_by_last: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByOrderAmountChangeRateByLast',
  },
  order_by_order_amount_change_rate_by_last_year: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByOrderAmountChangeRateByLastYear',
  },
  order_by_new_customer_count: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewCustomerCount',
  },
  order_by_new_customer_count_change_rate_by_last: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewCustomerCountChangeRateByLast',
  },
  order_by_new_customer_count_change_rate_by_last_year: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewCustomerCountChangeRateByLastYear',
  },
  order_by_new_paid_customer_count: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewPaidCustomerCount',
  },
  order_by_new_paid_customer_count_change_rate_by_last: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewPaidCustomerCountChangeRateByLast',
  },
  order_by_new_paid_customer_count_change_rate_by_last_year: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByNewPaidCustomerCountChangeRateByLastYear',
  },
  order_by_paid_rate: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByPaidRate',
  },
  order_by_paid_rate_change_rate_by_last: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByPaidRateChangeRateByLast',
  },
  order_by_paid_rate_change_rate_by_last_year: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByPaidRateChangeRateByLastYear',
  },
  order_by_customer_count: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByCustomerCount',
  },
  order_by_customer_count_change_rate_by_last: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByCustomerCountChangeRateByLast',
  },
  order_by_customer_count_change_rate_by_last_year: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByCustomerCountChangeRateByLastYear',
  },
  order_by_pending_receivable_amount: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByPendingReceivableAmount',
  },
  order_by_overdue_receivable_amount: {
    model_name: 'CustomReport',
    column_type: 'string',
    column_name: 'orderByOverdueReceivableAmount',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('CustomReport', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('CustomReport', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
